// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blocks[data-v-7e5203da]{width:32%}.map-data[data-v-7e5203da]{width:100%}.map-data p[data-v-7e5203da]{margin:0}", ""]);
// Exports
module.exports = exports;
